<template>
  <div class="banner">
    <div class="content">
      <el-carousel
        :interval="5000"
        arrow="never"
        :height="screenheight"
        @change="change"
      >
        <el-carousel-item v-for="item in banner" :key="item.id">
          <img :src="item.image" mode="widthFix" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      class="page wow animate__zoomIn"
      data-wow-duration="1s"
      data-wow-delay="0.5s"
    >
      <h3>同城配送一站式接单平台</h3>
      <p>Fast, efficient, safe and auspicious logistics</p>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  components: {},
  data() {
    return {
      current: 0,
      screenheight: document.documentElement.clientHeight + "px",
      banner: [
        {
          id: 0,
          image: require("../assets/img/banner/banner1.png"),
        },
        {
          id: 1,
          image: require("../assets/img/banner/banner2.png"),
        },
      ],
    };
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true, // 对异步加载的内容进行操作（默认值为true）
      callback: function(box) {
        // 每次启动动画时都会触发回调,传入的参数是正在设置动画的DOM节点
      },
      scrollContainer: null, // 可选滚动容器选择器，否则使用window，
      resetAnimation: true, // 结束时重置动画（默认为true）
    });
    wow.init();

    this.screenheight =
      Math.round((document.documentElement.clientWidth * 649) / 1440) + "px";
  },
  created() {
    window.addEventListener("resize", () => {
      this.screenheight =
        Math.round((document.documentElement.clientWidth * 649) / 1440) + "px";
    });
  },
  methods: {
    change(index) {
      this.current = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  min-width: 1000px;
  position: relative;
  ::v-deep .el-carousel__container {
    position: relative;
  }
}

.page {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* 使用transform来居中元素 */
  transition: transform 0.5s ease;
  text-align: center;
  overflow: hidden;
  z-index: 999;
  color: #fff;
  h3 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 48px;
    font-style: normal;
    margin: 0;
  }
  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    font-style: normal;
  }
}

.el-carousel {
  width: 100%;
}

img {
  width: 100%; /* 宽度占满容器 */
  height: auto; /* 高度自动调整以保持纵横比 */
  object-fit: contain; /* 图片将完全包含在容器内，但可能不完全覆盖容器 */
  /* 如果想要图片覆盖整个容器，即使裁剪，则使用 */
  /* object-fit: cover; */
}

::v-deep .el-carousel__button {
  width: 20px;
  height: 4px;
  background-color: #d3dce9;
}

::v-deep .el-carousel__indicator.is-active button {
  width: 26px;
  background-color: #084fff;
}
</style>
